import { uuid } from 'vue-uuid';

import ProductionUnits
  from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/ProductionUnits';

export default {
  data() {
    return {
      titleExp: '',
      statusExp: '',
      availableStatusExp: [],
      justification: '',
      state: null,
      showConfirm: false,
      dntCode: '',
      productionUnitOptions: ProductionUnits,
      // eslint-disable-next-line
      phoneRegex: /^[\+][0-9]{10,11}$/,
      distribution: '',
      signer: '',
      classification: null,
      inputFormat: 'paper',
      sender: 'naturalPerson',
      documentType: '',
      agency: 'legislativePower',
      motherDocNumber: undefined,
      isMotherDocument: 1,
      selectedCommune: '',
      address: '',
      phone: '',
      email: '',
      name: '',
      iut: '',
      inputDate: new Date().toLocaleString('es-CL', { dateStyle: 'long' }),
      numDoc: null,
      docCode: '',
      legalRepresentative: '',
      subjects: [],
      copies: [],
      mainFile: {},
      additionalFiles: [],
      commissions: null,
      adhesion: null,
      proposalStatus: '',
      referencedDocument: '',
      entity: '',
      theme: '',
      description: '',
      dateOfIssue: '',
      issuerContactName: '',
      issuerContactEmail: '',
      signers: [],
      certifiers: [],
      sendToPartsOffice: '',
      conventionalName: '',
      authors: [],
      references: [],
      metadata: {
        description: '',
        alternativeTitle: '',
        idSaip: '',
        documentDate: '',
        documentEndDate: '',
        externalAuthorName: '',
        externalAuthorRol: '',
        externalAuthorRolFree: '',
        productionUnit: '',
        productionUnitOther: '',
        internAuthors: [],
        externalAuthors: []
      },
      agencyOptions: [
        {
          value: 'centralAdministration',
          text: 'Organismos de la administración central (OAE)'
        },
        {
          value: 'legislativePower',
          text: 'Poder Legislativo'
        },
        {
          value: 'powerOfAttorney',
          text: 'Poder Judicial'
        },
        {
          value: 'docDigital',
          text: 'Doc. Digital'
        }
      ],
      isMotherOptions: [
        {
          value: 0,
          text: 'No'
        },
        {
          value: 1,
          text: 'Si'
        }
      ],
      error: {
        subject: '',
        clasification: '',
        onlyPdf: '',
        motherDoc: '',
        mainFile: ''
      },
      categoryNumber: undefined
    };
  },
  methods: {
    getSubjects() {
      return [
        ...this.subjects.map((sbj) => ({
          destinoCodigo: sbj.subjectType.value,
          destinoCodigoId: sbj.subjectType.id,
          destinoCorreo: sbj.subjectEmail,
          destinoListaCodigo: sbj.subject.id,
          destinoListaCodigoId: sbj.subject.id,
          destinoListaNombre: sbj.subject.label,
          destinoNombre: sbj.subjectType.label,
          estado: 1,
          providenciaId: sbj.providence.toString(),
          providenciaVencimiento: sbj.providenceExpiration,
          tipoDestino: 1
        })),
        ...this.copies.map((copySbj) => ({
          destinoCodigo: copySbj.copySubjectType.value,
          destinoCodigoId: copySbj.copySubjectType.id,
          destinoCorreo: copySbj.copySubjectEmail,
          destinoListaCodigo: copySbj.copySubject.id,
          destinoListaCodigoId: copySbj.copySubject.id,
          destinoListaNombre: copySbj.copySubject.label,
          destinoNombre: copySbj.copySubjectType.label,
          estado: 1,
          providenciaId: copySbj.providence.toString(),
          providenciaVencimiento: copySbj.providenceExpiration,
          tipoDestino: 2
        }))
      ];
    },
    getFlow() {
      const INPUT = 1; // Cuando el documento es de entrada va 1
      const OUTPUT = 2; // Cuando el documento es de entrada pero es convencional
      const INTERNAL = 3; // Cuando el documento es interno o se genero desde aprobaciones
      if (+this.categoryNumber === INTERNAL) {
        return INTERNAL;
      }
      if (this.sender === 'conventional' || this.sender === 'commission' || this.sender
        === 'user') {
        return OUTPUT;
      }
      return INPUT;
    },
    getDnt(state) {
      const PUBLIC = '0';
      let dnt = {
        tipo: 'EXP',
        claseMercadoPublico: 'ext',
        numeroInt: this.numDoc,
        categoria: `${this.classification}-${this.getFlow()}`,
        emisorCentroCostoNombre: this.$refs.documentTypes.getOption()?.label,
        emisorCentroCostoNumero: this.documentType,
        emisorContactoDocumentoId: this.sendToPartsOffice,
        compradorArea: this.getSender(),
        emisorRut: this.company.iut,
        receptorRut: this.company.iut,
        despachoContactoNombre: this.name,
        despachoContactoRut: this.iut,
        despachoDireccion: this.address,
        despachoComuna: this.selectedCommune,
        despachoContactoEmail: this.email,
        despachoContactoTelefono: this.phone,
        estado: state,
        titulo: this.titleExp,
        transporteTransportistaCargo: this.agency,
        transporteEmbalajeTara: 'inputDocForm',
        estadoCodigoEstadoComprador: this.isMotherDocument,
        despachoContactoDocumentoId: this.motherDocNumber,
        transporteEmbalajeSello: this.getInputFormat(),
        transporteTransportistaNombre: this.legalRepresentative,
        transporteNotas: this.distribution || this.entity,
        transportePuertoNombre: this.signer,
        solicitanteArea: this.commissions,
        transporteViaTransporteCodigoTransporte: this.isDigital ? '0' : '1', // 1 es si, 0 es no
        condicionDespacho: this.isDigital ? '1' : '0', // 1 es si, 0 es no
        plazo: this.adhesion,
        transporteViaTransporteVehiculoPatente: this.proposalStatus,
        fechaEmision: this.dateOfIssue,
        emisorContactoNombre: this.issuerContactName ? this.issuerContactName : this.name,
        emisorContactoEmail: this.issuerContactEmail ? this.issuerContactEmail : this.email,
        emisorContactoTelefono: this.phone,
        transportePuertoTipo: PUBLIC
      };
      const { febosId } = this.$route.query;
      if (this.detailsFile.dnt && this.detailsFile.dnt.solicitanteCodigo
        && this.detailsFile.dnt.febosId === febosId) {
        dnt.solicitanteCodigo = this.detailsFile.dnt.solicitanteCodigo;
      }
      if (this.detailsFile.dnt && this.detailsFile.dnt.nombreDescriptivo
        && this.detailsFile.dnt.febosId === febosId) {
        dnt.nombreDescriptivo = this.detailsFile.dnt.nombreDescriptivo;
      }
      if (dnt.compradorArea === 'Convencional' || dnt.compradorArea === 'Usuario') {
        dnt = {
          ...dnt,
          emisorContactoNombre: this.conventionalName,
          despachoContactoNombre: this.conventionalName
        };
      } else if (dnt.compradorArea === 'Organismo del estado') {
        dnt = {
          ...dnt,
          emisorContactoNombre: this.signer,
          despachoContactoNombre: this.signer
        };
      }
      return dnt;
    },
    addUserData(user) {
      this.issuerContactName = user.label;
      this.issuerContactEmail = user.email;
    },
    addAuthor(user) {
      const existingAuthor = this.authors.find((author) => author.usuarioAutorId === user.id);
      if (existingAuthor) {
        this.notify('El autor ya existe', 'danger', 'Ups!');
        return;
      }

      const mappedUser = {
        usuarioAutorId: user.id,
        usuarioAutorNombre: user.label
      };
      this.authors.push(mappedUser);
    },
    addInternAuthor(user) {
      const existingAuthor = this.metadata.internAuthors.find((author) => author.id === user.id);
      if (existingAuthor) {
        this.notify('El autor ya existe', 'danger', 'Ups!');
        return;
      }

      const mappedUser = {
        id: user.id,
        'dc.contributor.name': user.label,
        'dc.contributor.type': user.rol
      };
      this.metadata.internAuthors.push(mappedUser);
    },
    addExternalAuthor() {
      if (!this.metadata.externalAuthorName || !this.metadata.externalAuthorRol) {
        this.notify('Completa los datos para poder agregar el autor', 'danger', 'Ups!');
        return;
      }
      if (this.metadata.externalAuthorRol === 'Otro' && !this.metadata.externalAuthorRolFree) {
        this.notify('Completa los datos para poder agregar el autor', 'danger', 'Ups!');
        return;
      }
      const mappedUser = {
        id: uuid.v1(),
        'dc.contributor.name': this.metadata.externalAuthorName,
        'dc.contributor.type': this.metadata.externalAuthorRol === 'Otro'
          ? this.metadata.externalAuthorRolFree : this.metadata.externalAuthorRol
      };
      this.metadata.internAuthors.push(mappedUser);
      this.metadata.externalAuthorName = '';
      this.metadata.externalAuthorRol = '';
    },
    removeMetadataAuthor(type, author) {
      if (type === 'intern') {
        this.metadata.internAuthors = this.metadata.internAuthors.filter(
          (user) => user.id !== author.id
        );
      } else {
        this.metadata.externalAuthors = this.metadata.externalAuthors.filter(
          (user) => user.id !== author.id
        );
      }
    },
    removeAuthor(authorId) {
      this.authors = this.authors.filter((author) => author.usuarioAutorId !== authorId);
    },
    addSubject(row) {
      if (row.subject.id === this.currentUser.id) {
        this.notify('No te puedes agregar como destinatario', 'danger', 'Ups!');
        return;
      }
      this.subjects = [];
      this.subjectsSelected = [];
      this.subjects.push(row);
    },
    addCopy(row) {
      if (row.copySubject.id === this.currentUser.id) {
        this.notify('No te puedes agregar como copia', 'danger', 'Ups!');
        return;
      }
      const isSelected = this.copies.some(
        (copyRow) => copyRow.copySubject.id === row.copySubject.id
      );
      if (isSelected) {
        this.notify('Ya agregaste esta copia', 'danger', 'Ups!');
        return;
      }

      this.copies.push(row);
    },
    removeCopy(copyToDelete) {
      this.copies = this.copies.filter(
        (copy) => copy.copySubject.id !== copyToDelete.copySubject.id
      );
    },
    getSender() {
      let sender = '';
      if (this.sender === 'naturalPerson') sender = 'Ciudadano/a';
      if (this.sender === 'legalPerson') sender = 'Persona jurídica';
      if (this.sender === 'stateAgency') sender = 'Organismo del estado';
      if (this.sender === 'conventional') sender = 'Convencional';
      if (this.sender === 'commission') sender = 'Comisión';
      if (this.sender === 'user') sender = 'Usuario';
      return sender;
    },
    getInputFormat() {
      let inputFormat = '';
      if (this.isPaper) inputFormat = 'Papel';
      if (this.isDigital) inputFormat = 'Digital';
      if (this.isPaperAndDigital) inputFormat = 'Papel y Digital';
      return inputFormat;
    },
    getParticipants() {
      const SIGNER = 1;
      const CERTIFIER = 2;

      const certifiers = this.certifiers.map((certifier) => ({
        tipo: CERTIFIER,
        personaId: certifier.id,
        entidadId: certifier.entityId,
        nombre: certifier.name,
        nombreEntidad: certifier.entityName,
        status: certifier.status
      }));

      const signers = this.signers.map((signer) => ({
        tipo: SIGNER,
        personaId: signer.id,
        entidadId: signer.entityId,
        nombre: signer.name,
        nombreEntidad: signer.entityName,
        status: signer.status
      }));

      const participants = certifiers.concat(signers);
      return participants;
    },
    getReferences() {
      const references = !this.isMotherDocument
        ? this.references
        : this.references.filter((ref) => ref.codigo !== 'mother');
      if (this.fromDocDigital) {
        return [...references, ...this.wizardStorage.referencias];
      }
      return references;
    },
    getObservations() {
      let observations = [];
      if (this.fromDocDigital) {
        observations = [
          {
            linea: '0',
            observacion: this.theme
          },
          {
            linea: '1',
            observacion: this.description
          }
        ];
      }
      return observations;
    },
    getMetadata() {
      const { metadata } = this.detailsFile;
      const metadataDnt = [
        { nombre: 'justification', tipo: 1, valor: this.justification },
        { nombre: 'dc.description', tipo: 1, valor: this.metadata.description },
        { nombre: 'dc.title.alternative', tipo: 1, valor: this.metadata.alternativeTitle },
        { nombre: 'dc.identifier.SAIP', tipo: 1, valor: this.metadata.idSaip },
        { nombre: 'dc.date.issued', tipo: 1, valor: this.metadata.documentDate },
        { nombre: 'dc.date.fin', tipo: 1, valor: this.metadata.documentEndDate },
        { nombre: 'dc.contributors', tipo: 2, valor: JSON.stringify(this.metadata.internAuthors) },
        {
          nombre: 'dc.publicher',
          tipo: 1,
          valor: this.metadata.productionUnit !== 'Otro'
            ? this.metadata.productionUnit : this.metadata.productionUnitOther
        }
      ];

      const { febosId } = this.$route.query;
      if (metadata && this.detailsFile.dnt.febosId === febosId) {
        metadata.forEach((field) => {
          if (field.nombre === 'title') {
            metadataDnt.push({ nombre: 'title', tipo: 1, valor: field.valor });
          }
          if (field.nombre === 'keywords') {
            metadataDnt.push({ nombre: 'keywords', tipo: 2, valor: field.valor });
          }
          if (field.nombre === 'constitute') {
            metadataDnt.push({ nombre: 'constitute', tipo: 1, valor: field.valor });
          }
          if (field.nombre === 'relation') {
            metadataDnt.push({ nombre: 'relation', tipo: 2, valor: field.valor });
          }
          if (field.nombre === 'isPartOf') {
            metadataDnt.push({ nombre: 'isPartOf', tipo: 1, valor: field.valor });
          }
          if (field.nombre === 'acceso') {
            metadataDnt.push({ nombre: 'acceso', tipo: 1, valor: field.valor });
          }
          if (field.nombre === 'notes') {
            this.notes = JSON.parse(field.valor);
            metadataDnt.push({ nombre: 'notes', tipo: 2, valor: field.valor });
          }
          if (field.nombre === 'idioma') {
            metadataDnt.push({ nombre: 'idioma', tipo: 2, valor: field.valor });
          }
        });
      }
      return metadataDnt;
    },
    getAttachments() {
      const attachments = this.additionalFiles.map((file) => ({
        adjuntoId: file.id,
        adjuntoMime: file.mime,
        adjuntoNombre: file.name,
        tipoDescripcion: file.currentDescription,
        adjuntoUrl: file.path,
        fecha: file.date,
        tipo: 'adjunto',
        otraReferenciaId: file.trueCopy,
        estado: file.status
      }));
      if (Object.keys(this.mainFile).length) {
        attachments.push({
          adjuntoId: this.mainFile.id,
          adjuntoMime: this.mainFile.mime,
          adjuntoNombre: this.mainFile.name,
          tipoDescripcion: this.mainFile.currentDescription,
          adjuntoUrl: this.mainFile.path,
          fecha: this.mainFile.date,
          tipo: 'principal',
          otraReferenciaId: this.mainFile.trueCopy,
          estado: this.mainFile.status
        });
      }
      return attachments;
    },
    clearCommune() {
      this.selectedCommune = '';
    },
    onlyPDF() {
      return this.mainFile.mime === 'application/pdf';
    },
    resetValidations() {
      // eslint-disable-next-line
      this.error.subject = '',
      this.error.clasification = '';
      this.error.onlyPdf = '';
      this.error.motherDoc = '';
      this.error.mainFile = '';
    },
    async validateForm() {
      this.resetValidations();
      let valid = false;
      const isValid = await this.$validator.validateAll('inputDoc');
      if (!isValid) {
        this.notify('Hay campos que falta completar', 'danger', 'Ups!');
        return valid;
      }
      if (!this.subjects.length) {
        this.notify('El destinatario es obligatorio', 'danger', 'Ups!');
        this.error.subject = 'El destinatario es obligatorio';
      }
      if (!this.classification) {
        this.notify('La clasificación es obligatoria', 'danger', 'Ups!');
        this.error.clasification = 'La clasificación es obligatoria';
      }
      if (
        !this.onlyPDF()
        && this.inputFormat !== 'paper'
        && (!this.fromDocDigital || !this.docDigitalCode)
      ) {
        this.error.onlyPdf = 'El archivo principal solo puede ser formato PDF';
      }
      if (this.inputFormat !== 'paper' && !Object.keys(this.mainFile).length) {
        this.error.mainFile = 'El documento principal es obligatorio';
      }
      if (!this.isMotherDocument) {
        const reference = this.references.find((ref) => ref.codigo === 'mother');
        if (!reference) {
          this.error.motherDoc = 'El documento madre no existe';
          this.notify('El documento madre no existe', 'danger', 'Ups!');
        }
      }
      valid = Object.values(this.error).every((error) => !error);
      return valid;
    },
    resetData() {
      this.justificationCompleted = false;
      this.justification = '';
      this.statusExp = '';
      this.titleExp = '';
      this.showConfirm = false;
      this.dntCode = '';
      this.distribution = '';
      this.signer = '';
      this.classification = null;
      this.inputFormat = 'paper';
      this.sender = 'naturalPerson';
      this.documentType = '';
      this.agency = 'legislativePower';
      this.motherDocNumber = '';
      this.isMotherDocument = 1;
      this.selectedCommune = '';
      this.address = '';
      this.phone = '';
      this.email = '';
      this.name = '';
      this.iut = '';
      this.inputDate = new Date().toLocaleString('es-CL', { dateStyle: 'long' });
      this.numDoc = null;
      this.docCode = '';
      this.legalRepresentative = '';
      this.subjects = [];
      this.copies = [];
      this.mainFile = {};
      this.additionalFiles = [];
      this.commissions = null;
      this.adhesion = null;
      this.proposalStatus = '';
      this.entity = '';
      this.theme = '';
      this.description = '';
      this.signers = [];
      this.certifiers = [];
      this.sendToPartsOffice = '';
      this.conventionalName = '';
      this.authors = [];
      this.references = [];
      this.metadata = {
        description: '',
        alternativeTitle: '',
        idSaip: '',
        documentDate: '',
        documentEndDate: '',
        externalAuthorName: '',
        externalAuthorRol: '',
        externalAuthorRolFree: '',
        productionUnit: '',
        productionUnitOther: '',
        internAuthors: [],
        externalAuthors: []
      };
      this.$router.replace({ name: 'conventionInputForm' });
      this.$validator.reset();
    },
    getSenderValue() {
      let sender = '';
      const { compradorArea } = this.detailsFile.dnt;
      if (compradorArea === 'Ciudadano/a') sender = 'naturalPerson';
      if (compradorArea === 'Persona jurídica') sender = 'legalPerson';
      if (compradorArea === 'Organismo del estado') sender = 'stateAgency';
      if (compradorArea === 'Convencional') sender = 'conventional';
      if (compradorArea === 'Comisión') sender = 'commission';
      if (compradorArea === 'Usuario') sender = 'user';
      return sender;
    },
    getInputFormatValue() {
      const format = this.detailsFile.dnt.transporteEmbalajeSello;
      let inputFormat = '';
      if (format === 'Papel') inputFormat = 'paper';
      if (format === 'Papel y Digital') inputFormat = 'paper_digital';
      if (format === 'Digital') inputFormat = 'digital';
      return inputFormat;
    },
    fillDraftData() {
      const {
        dnt,
        adjuntos,
        referencias,
        metadata
      } = this.detailsFile;
      const SIGNER = 1;
      const CERTIFIER = 2;
      const MAIN_SUBJECT = '1';
      const COPY_SUBJECT = '2';
      this.files = adjuntos;
      try {
        const [categoryNumber] = dnt.categoria?.split('-').reverse();
        this.categoryNumber = parseInt(categoryNumber, 10);
        this.classification = dnt.categoria.split('-').slice(0, -1).join('-');
      } catch (e) {
        console.error('Sin categoria', e);
        this.categoryNumber = undefined;
        this.classification = undefined;
      }
      if (dnt.tipoFlujo && !Number.isNaN(dnt.tipoFlujo)) {
        this.categoryNumber = parseInt(dnt.tipoFlujo, 10);
      }
      try {
        this.distribution = dnt.transporteNotas;
        this.signer = dnt.transportePuertoNombre;
        this.sender = this.getSenderValue();
        this.documentType = dnt.emisorCentroCostoNumero;
        this.titleExp = dnt.titulo;
        this.agency = dnt.transporteTransportistaCargo;
        this.motherDocNumber = referencias.find((ref) => ref.codigo === 'mother')?.folio;
        this.isMotherDocument = parseInt(dnt.estadoCodigoEstadoComprador, 10);
        this.selectedCommune = dnt.despachoComuna;
        this.address = dnt.despachoDireccion;
        this.phone = dnt.despachoContactoTelefono;
        this.email = dnt.despachoContactoEmail;
        this.name = dnt.despachoContactoNombre;
        this.iut = dnt.despachoContactoRut;
        this.inputDate = dnt.fechaCreacion;
        this.numDoc = dnt.numeroInt;
        this.docCode = `${dnt.categoria}-${dnt.numeroExt}`;
        this.legalRepresentative = dnt.transporteTransportistaNombre;
        this.docDigitalCode = dnt.receptorSucursalCodigo;
      } catch (e) {
        console.error('Error al llenar datos', e);
      }
      try {
        this.subjects = this.detailsFile.destinatarios.filter(
          (subject) => subject.tipoDestino === MAIN_SUBJECT
        ).map((subject) => {
          const subjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            subjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            subject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            subjectEmail: subject.destinoCorreo,
            status: subject.estado,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento?.substring(0, 10) || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            subjectTypeDigitalDoc
          };
        });
      } catch (e) {
        console.error('Error al llenar destinatarios', e);
      }
      try {
        this.copies = this.detailsFile.destinatarios.filter(
          (subject) => subject.tipoDestino === COPY_SUBJECT
        ).map((subject) => {
          const copySubjectTypeDigitalDoc = subject.institucionCodigo
            ? {
              id: subject.institucionCodigoId,
              value: subject.institucionCodigo,
              label: subject.institucionNombre
            }
            : {};

          return {
            copySubjectType: {
              id: subject.destinoCodigoId,
              value: subject.destinoCodigo,
              label: subject.destinoNombre
            },
            copySubject: {
              id: subject.destinoListaCodigoId,
              value: subject.destinoListaCodigo,
              label: subject.destinoListaNombre
            },
            copySubjectEmail: subject.destinoCorreo,
            providence: subject.providenciaId || '',
            providenceExpiration: subject.providenciaVencimiento?.substring(0, 10) || '',
            dntDestinatariosId: subject.dntDestinatariosId,
            status: subject.estado,
            copySubjectTypeDigitalDoc
          };
        });
      } catch (e) {
        console.error('Error al llenar copias', e);
      }
      try {
        this.commissions = dnt.solicitanteArea;
        this.adhesion = dnt.plazo;
        this.proposalStatus = dnt.transporteViaTransporteVehiculoPatente;
        this.entity = dnt.transporteNotas;
        this.theme = this.detailsFile.observaciones.length
          ? this.detailsFile.observaciones[0]?.observacion
          : '';
        this.description = this.detailsFile.observaciones.length
          ? this.detailsFile.observaciones[1]?.observacion
          : '';
        this.signers = this.detailsFile.docDigitalParticipantes.filter(
          (signer) => signer.tipo === SIGNER
        ).map((signer) => ({
          id: signer.personaId,
          entityId: signer.entidadId,
          name: signer.nombre,
          entityName: signer.nombreEntidad,
          status: signer.status
        }));
        this.certifiers = this.detailsFile.docDigitalParticipantes.filter(
          (certifier) => certifier.tipo === CERTIFIER
        ).map((certifier) => ({
          id: certifier.personaId,
          entityId: certifier.entidadId,
          name: certifier.nombre,
          entityName: certifier.nombreEntidad,
          status: certifier.status
        }));
        this.sendToPartsOffice = dnt.emisorContactoDocumentoId;
        this.authors = this.detailsFile.docDigitalAutores;
      } catch (e) {
        console.error('Error al llenar autores', e);
      }
      try {
        let inputFormat = '';
        if (dnt.transporteEmbalajeSello === 'Papel') inputFormat = 'paper';
        if (dnt.transporteEmbalajeSello === 'Papel y Digital') inputFormat = 'paper_digital';
        if (dnt.transporteEmbalajeSello === 'Digital') inputFormat = 'digital';
        this.inputFormat = inputFormat;
      } catch (e) {
        console.error('Error al llenar formato de entrada', e);
      }
      try {
        this.references = referencias;
        metadata.forEach((field) => {
          if (field.nombre === 'dc.description') {
            this.metadata.description = field.valor;
          }
          if (field.nombre === 'dc.title.alternative') {
            this.metadata.alternativeTitle = field.valor;
          }
          if (field.nombre === 'dc.identifier.SAIP') {
            this.metadata.idSaip = field.valor;
          }
          if (field.nombre === 'dc.date.issued') {
            this.metadata.documentDate = field.valor;
          }
          if (field.nombre === 'dc.date.fin') {
            this.metadata.documentEndDate = field.valor;
          }
          if (field.nombre === 'dc.contributors') {
            this.metadata.internAuthors = JSON.parse(field.valor);
          }
          if (field.nombre === 'dc.publicher' && field.valor && field.valor !== '') {
            if (field.valor === 'Convención Constitucional') {
              this.metadata.productionUnit = field.valor;
            } else {
              this.metadata.productionUnit = 'Otro';
              this.metadata.productionUnitOther = field.valor;
            }
          }
        });
      } catch (e) {
        console.error('Error al llenar metadatos', e);
      }
    }
  }
};
